module.exports = __webpack_public_path__ + "static/img/product_images_04.e452505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/chataxera/product_images_04.png
// module id = LFHC
// module chunks = 34